import ROUTES from '@agency/routes/routes.constant';
import { DisposalInterestShowItem } from '@shared/apis/disposals';
import { getQueriesAsSearch } from '@shared/utils/common';

import { getRecordInterestSource } from '../../components/disposal-record-drawer/DisposalRecordDrawer.utils';

export const getDisposalReportingSchedulePath = (disposalId: string, params?: Query) => {
  const managePrefix = ROUTES.organisation.disposals.manage.root(disposalId);

  return `${managePrefix}${ROUTES.organisation.disposals.manage.reporting}${getQueriesAsSearch({
    schedule_tab: 'all',
    schedule_view_type: 'table',
    space: 'schedule',
    ...params,
  })}`;
};

export const getDisposalReportingViewInterestPath = (disposalId: string, interestId: string, params?: Query) => {
  const managePrefix = ROUTES.organisation.disposals.manage.root(disposalId);

  return `${managePrefix}${ROUTES.organisation.disposals.manage.reporting}${getQueriesAsSearch({
    schedule_tab: 'all',
    schedule_view_type: 'table',
    space: 'schedule',
    view_interest: interestId.toString(),
    ...params,
  })}`;
};

export const getDisposalReportingRecordInterestPath = (disposalId: string, interestId: string, interestSource = '') =>
  getDisposalReportingSchedulePath(disposalId, {
    record_interest: interestId.toString(),
    ...(interestSource ? { record_interest_source: interestSource } : {}),
  });

// Hand-off for surfaces that do not render the disposal record drawer themselves: opens the owning
// disposal's schedule in a new tab with the record drawer already open
export const openDisposalReportingRecordInterest = (
  interest: Pick<DisposalInterestShowItem, 'disposal_id' | 'id' | 'status'>
) => {
  window.open(
    getDisposalReportingRecordInterestPath(
      interest.disposal_id.toString(),
      interest.id.toString(),
      getRecordInterestSource(interest.status)
    ),
    '_blank',
    'noopener,noreferrer'
  );
};

export const getDisposalReportingOutboundThreadPath = (disposalId: string, threadId: string, params?: Query) => {
  const managePrefix = ROUTES.organisation.disposals.manage.root(disposalId);

  return `${managePrefix}${ROUTES.organisation.disposals.manage.reporting}${getQueriesAsSearch({
    outbound_tab: 'sent',
    space: 'outbound',
    threadId: threadId.toString(),
    ...params,
  })}`;
};
